<template>
  <div>
    <FDBannerImg />
    <div class="navigation">
      <div class="page-cen">
        <div class="navigation-item">
          <a href="javascript:void(0)" @click="goPage('/home')">首页</a
          >&nbsp;&gt;
          <a class="active" href="javascript:void(0)">学位论文</a>
        </div>
      </div>
    </div>

    <div class="search_banner">
      <div class="tips_box">
        <div>
          本学院硕士研究生以上的历年学位论文可以通过<el-link
            type="primary"
            href="https://thesis.fudan.edu.cn"
            target="_blank"
            referrerpolicy="no-referrer"
            >复旦大学学位论文数据库</el-link
          >在线阅览。
        </div>
        <div>
          管理学院图书馆提供近三年硕士优秀论文和博士论文纸本阅览服务，馆藏位置：4楼阅览室。馆藏目录如下：
        </div>
      </div>
      <div class="search_group">
        <div class="search_left">
          <el-select
            v-model="searchType"
            style="max-width: 150px; margin-right: 6px"
          >
            <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="searchValue"
            placeholder="请输入检索关键词"
            @keyup.enter.native="handleCurrentChange"
            clearable
          />
        </div>
        <div class="search_right" @click="handleCurrentChange">
          <svg-icon
            icon-class="search"
            style="font-size: 14px; color: #fff; margin-right: 5px"
          />
          检索
        </div>
      </div>
    </div>
    <div class="container">
      <div class="tag">
        <div
          :class="tag == item ? 'tag_item active_tag' : 'tag_item'"
          v-for="(item, index) in tagList"
          :key="item"
          @click="selectTag(item, index)"
        >
          {{ item }}
        </div>
      </div>
      <div class="content">
        <div class="content_list" v-if="total > 0">
          <el-table :data="dataList" stripe style="width: 100%">
            <el-table-column prop="bindingNumber" label="装订号">
            </el-table-column>
            <el-table-column prop="title" label="论文名称"> </el-table-column>
            <el-table-column prop="type" label="论文类型" width="120">
              <template slot-scope="scope">
                {{ getTypeNameByCode(scope.row.type) }}
              </template>
            </el-table-column>
            <el-table-column prop="studentName" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="studentId" label="学号" width="120">
            </el-table-column>
            <el-table-column prop="tutor" label="指导教师" width="120">
            </el-table-column>
            <el-table-column prop="specialty" label="专业" width="150">
            </el-table-column>
          </el-table>
          <Pagination
            v-if="total > 0"
            :total="total"
            :page.sync="currentPage"
            :limit.sync="pageSize"
            @pagination="loadList"
          />
        </div>
        <div v-if="total == 0" class="empty">
          <img src="../../assets/empty.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import FDBannerImg from "@c//FDBannerImg";

import { post, get } from "@u/request";

export default {
  name: "",
  components: { Pagination, FDBannerImg },
  data() {
    return {
      logo: "",
      copyright: {},
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dataList: [],
      tag: "全部",
      tagIndex: 0,
      tagList: ["全部"],
      searchType: "title",
      searchValue: "",
      searchOptions: [
        {
          value: "bindingNumber",
          label: "装订号",
        },
        {
          value: "title",
          label: "论文名称",
        },
        {
          value: "studentName",
          label: "姓名",
        },

        {
          value: "studentId",
          label: "学号",
        },
        {
          value: "tutor",
          label: "指导教师",
        },
        {
          value: "specialty",
          label: "专业",
        },
      ],
    };
  },
  computed: {
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    selectTag(item, index) {
      this.tag = item;
      this.tagIndex = index;
      this.loadList();
    },
    handleCurrentChange() {
      this.currentPage = 1;
      this.loadList();
    },
    // toDetail(item) {
    //   this.$router.push(`/news/detail/${item.id}`);
    // },
    async loadList() {
      const params = {
        status: 1,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        menuId: 10023,
      };
      if (this.tagIndex !== 0) {
        params.type = this.tagIndex - 1;
      }

      if (this.searchValue) {
        params[this.searchType] = this.searchValue;
      }

      const { rows, total } = await get("lib/thesis/list", params).catch(
        () => {}
      );
      this.dataList = rows;
      this.total = total;
    },
    getTypeNameByCode(type) {
      return this.tagList[type + 1];
    },
    goPage(url) {
      this.$router.push(url);
    },
    async getDegreeType() {
      let { data } = await get("system/dict/data/getList", {
        dictType: "degree_type",
      }).catch(() => {});
      data = data.map((item) => item.dictLabel);
      this.tagList.push(...data);
    },
  },
  created() {
    this.getDegreeType();
    this.loadList();
  },
};
</script>

<style scoped lang="scss">
.banner_img {
  height: 220px;
  overflow: hidden;
  position: relative;
  img {
    // position:absolute;
    // top: -200px;
    // height: 600;
    // width: 100%;
  }
}

.search_banner {
  width: 1200px;
  overflow: hidden;
  margin: auto;
  .tips_box {
    padding: 20px 0 0 20px;
    font-size: 14px;
    color: #999;
    ::v-deep {
      .el-link {
        vertical-align: inherit;
      }
    }
  }
  .search_group {
    display: flex;
    box-sizing: border-box;
    margin: 16px auto 0;
    height: 40px;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    .search_left {
      width: 90%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 4px 20px;
    }
    .search_right {
      cursor: pointer;
      width: 100px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background-color: #004796;
      color: #fff;
      font-size: 14px;
    }
    .search_right:hover {
      background-color: #0150aa;
    }
  }
}

.container {
  width: 1200px;
  margin: 20px auto;
  padding-bottom: 96px;
  .tag {
    display: flex;
    .tag_item {
      cursor: pointer;
      border: 1px solid #cdcdcd;
      background: #fff;
      font-size: 12px;
      color: #525252;
      line-height: 29px;
      padding: 0 18px;
      margin-right: 10px;
      border-radius: 20px;
    }
    .tag_item:hover,
    .active_tag {
      background-color: #004796;
      color: #fff;
    }
  }
  .content {
    padding-top: 10px;
    .empty {
      text-align: center;
    }
    .content_list {
      margin-bottom: 80px;
      .list_item:hover {
        color: #004796;
      }
      .list_item {
        cursor: pointer;
        position: relative;
        display: flex;
        padding: 20px 0;
        border-bottom: 1px solid #dadada;
        color: #121212;
        .keyword {
          position: absolute;
          right: 100px;
          font-size: 12px;
          border-radius: 30px;
          min-width: 70px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          padding: 0 5px;
          border: 1px solid #cdcdcd;
          background: #fff;
          color: #525252;
        }
        .date {
          position: absolute;
          right: 0;
          color: #999;
          font-size: 14px;
        }
        // .color1 {
        //   background: #eff1ff;
        //   color: #0309b8;
        // }
        // .color2 {
        //   background: #d8ffff;
        //   color: #306eb4;
        // }
        // .color3 {
        //   background: #f6eeff;
        //   color: #82318e;
        // }
        // .color4 {
        //   background: #eee;
        //   color: #878787;
        // }
      }
    }
  }
}
</style>
